<main class="container" style="min-height: 73vh">
  <section id="column1" npSetLayout [pageLayout]="PageLayout.Layout12">
    <div class="row">
      <div class="col col-12">
        <h2>User Access</h2>

        <!-- Search bar -->
        <div class="search-bar">
          <input
            type="email"
            [(ngModel)]="searchEmail"
            placeholder="Search by email address"
            (keyup.enter)="search()"
            [disabled]="!isAdmin"
            class="email-input" />
          <select [(ngModel)]="selectedRegion" (ngModelChange)="search()" class="region-select">
            <option value="NA">NA</option>
            <option value="East">East</option>
          </select>
          <button *ngIf="isAdmin" (click)="search()" [disabled]="!searchEmail.trim()" class="btn-action">Search</button>
          <button *ngIf="isAdmin" (click)="clear()" class="btn-action">Clear</button>
        </div>
        <div class="access-info-row">
          <p *ngIf="!isAdmin" class="info-text">You are viewing your own access. Contact an admin to look up other users.</p>
          <a href="https://go.chevron.com/wv_snow" target="_blank" rel="noopener noreferrer" class="btn-request">
            Request Access
          </a>
        </div>

        <!-- Loading -->
        <div *ngIf="loading" class="loading-indicator">Loading...</div>

        <!-- Error -->
        <div *ngIf="error" class="error-message">{{ error }}</div>

        <!-- Not found -->
        <div *ngIf="notFound" class="not-found">
          No access records found for <strong>{{ searchEmail }}</strong>.
        </div>

        <!-- Results -->
        <div *ngIf="result" class="result-card">
          <p class="result-email">
            <span class="label">Email:</span> {{ result.email }}
          </p>
          <table>
            <thead>
              <tr>
                <th>Security Type</th>
                <th title="Can create new entities">Create</th>
                <th title="Can delete entities">Delete</th>
                <th title="Can update entities">Update</th>
                <th title="Can update security types">Update Sec Type</th>
                <th title="Can update lock">Update Lock</th>
                <th title="Can ignore lock">Ignore Lock</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let g of result.groups">
                <td>{{ g.securityType }}</td>
                <td><span class="perm-badge" [ngClass]="g.allowedToCreate ? 'perm-yes' : 'perm-no'">{{ g.allowedToCreate ? 'Yes' : 'No' }}</span></td>
                <td><span class="perm-badge" [ngClass]="g.allowedToDelete ? 'perm-yes' : 'perm-no'">{{ g.allowedToDelete ? 'Yes' : 'No' }}</span></td>
                <td><span class="perm-badge" [ngClass]="g.allowedToUpdate ? 'perm-yes' : 'perm-no'">{{ g.allowedToUpdate ? 'Yes' : 'No' }}</span></td>
                <td><span class="perm-badge" [ngClass]="g.allowedToUpdateSecType ? 'perm-yes' : 'perm-no'">{{ g.allowedToUpdateSecType ? 'Yes' : 'No' }}</span></td>
                <td><span class="perm-badge" [ngClass]="g.allowedToUpdateLock ? 'perm-yes' : 'perm-no'">{{ g.allowedToUpdateLock ? 'Yes' : 'No' }}</span></td>
                <td><span class="perm-badge" [ngClass]="g.allowedToIgnoreLock ? 'perm-yes' : 'perm-no'">{{ g.allowedToIgnoreLock ? 'Yes' : 'No' }}</span></td>
              </tr>
            </tbody>
          </table>
          <p class="group-count">{{ result.groups.length }} security group(s)</p>
        </div>

      </div>
    </div>
  </section>
</main>

